import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React from "react";

interface Props {
  products: any;
  ctes: any;
  show: boolean;
  onHide: any;
  onCreate: any;
  setProduct: (product: any) => void;
  setCte: (cte: any) => void;
  product: any;
  cte: any;
}

export default function NewBatch({
  products,
  ctes,
  show,
  onHide,
  onCreate,
  setProduct,
  setCte,
  product,
  cte,
}: Props) {
  return (
    <Dialog
      header="Create A New Tracking Batch"
      visible={show}
      onHide={onHide}
      style={{ width: "50vw" }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      blockScroll={true}
    >
      <div className="flex flex-column gap-4">
        <div className="p-fluid flex flex-column gap-2">
          <label>Select Product</label>

          <Dropdown
            value={product}
            options={products}
            onChange={(e) => setProduct(e.value)}
            optionLabel="name"
          />
        </div>

        <div className="p-fluid flex flex-column gap-2">
          {/* <label>Select Cte</label>

          <Dropdown
            value={cte}
            options={ctes}
            onChange={(e) => setCte(e.value)}
            optionLabel="name"
          /> */}
        </div>

        <Button
          label="Create"
          className="p-button-raised text-white mt-5"
          disabled={!product}
          onClick={onCreate}
        />
      </div>
    </Dialog>
  );
}
